import React from 'react'
import { addMinutes, differenceInMinutes, format } from 'date-fns'
import { useTheme } from '@chakra-ui/react'
import { Box, Text } from '@chakra-ui/react'

import { AppointmentFieldsFragment } from '~graphql/generated/graphql'

export const InsertAppointmentItem: React.FC<{
    appointment: AppointmentFieldsFragment
    startTime: number
    index: number
    spacing?: number
    hasConflict?: boolean
}> = ({ appointment, startTime, index, spacing = 56, hasConflict }) => {
    const theme = useTheme()

    const startDate = new Date(appointment.start_time)
    const endDate = new Date(
        addMinutes(appointment.start_time, appointment.minutes)
    )

    const bg = `rgba(180, 248, 215, 0.7)`
    const color = `rgba(0, 0, 0, 0.8)`

    const startHours = startDate.getHours()
    const startMinutes = startDate.getMinutes()

    const top =
        ((startHours - Math.floor(startTime)) * 4 + startMinutes / 15) *
        spacing +
        2

    const MIN_HEIGHT = 60
    const height = (differenceInMinutes(endDate, startDate) * spacing) / 15 - 3

    return (
        <Box
            key={'appt' + index}
            position="absolute"
            top={`${top}px`}
            left={0}
            w={hasConflict ? 'calc(50%)' : '100%'}
            px={1}
            role="group"
            transition="0.1s"
            zIndex={1}
        >
            <Box
                bg={hasConflict ? 'yellow.50' : 'white'}
                border={`4px dashed ${hasConflict
                        ? theme.colors.yellow[400]
                        : theme.colors.brand[500]
                    }`}
                w="full"
                opacity={1}
                // minH={`${24}px`}
                height={`${height}px`}
                overflow="hidden"
                _hover={{ maxH: '100%', zIndex: 1 }}
                rounded="lg"
                textAlign="left"
            >
                <Box pt={height > MIN_HEIGHT ? 2 : 1} px={4} pb={3}>
                    <Text color={color} fontSize="15px" fontWeight="semibold">
                        Requested Timeslot
                    </Text>
                    <Text color={color} fontSize="14px" fontWeight="semibold">
                        {format(startDate, 'h:mm a')} -{' '}
                        {format(endDate, 'h:mm a')}
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}
